export const key = 'anonymous_actions';
export const confirmedRatingsKey = 'confirmed_ratings';

function getKey(actionKey) {
  return `${key}:${actionKey}`;
}

export function getAnonymousAction(actionKey) {
  const key = getKey(actionKey);
  const anonAction = localStorage.getItem(key);
  try {
    return JSON.parse(anonAction);
  } catch (e) {
    return anonAction;
  }
}

export function removeAnonymousAction(actionKey) {
  localStorage.removeItem(getKey(actionKey));
}

export function setAnonymousAction(actionKey, actionValue) {
  if (actionValue === null || actionValue === undefined) {
    return;
  }
  if (typeof actionValue === 'object' || actionValue instanceof Array) {
    actionValue = JSON.stringify(actionValue);
  }
  const key = getKey(actionKey);
  localStorage.setItem(key, actionValue);
}
